import Loading from 'vue-loading-overlay'
import axios from 'axios'
import PaginationNav from '../../../components/PaginationNav.vue'
import PaginationMobile from '../../../components/PaginationMobile.vue'
import LoadingComp from '../../../components/LoadingComp.vue'
import TableSkeleton from '../../../components/TableSkeleton.vue'
import moment from 'moment'

import * as functions from '../../../functions/functions'
import * as config from '@/config.json'
import * as helpers from '../../../helpers/object-helper'

export default {
  name: 'DetailsItemsDocuments',
  components: {
    Loading,
    PaginationNav,
    PaginationMobile,
    LoadingComp,
    TableSkeleton
  },
  props: ['source'],
  data: () => {
    return {
      helperUrlImage: helpers.UrlImage.NO_IMAGE.url,
      token: null,
      isLoading: false,
      isBusy: false,
      pagination: {},
      paginationPageMobile: {},
      paginationRangeMobile: 5,
      paginationRange: 11,
      currentPage: 1,
      perPage: 8,
      totalRecords: 0,
      itemsTotals: [],
      fieldsItemsTotals: [
        {
          key: 'reason',
          label: 'Motivo'
        },
        {
          key: 'type',
          label: 'Transação'
        },
        {
          key: 'totalQuantity',
          label: 'Quantidade'
        },
        {
          key: 'totalCostAdjust',
          label: 'Total Custo'
        },
        {
          key: 'totalSaleAdjust',
          label: 'Total Venda'
        }
      ],
      itemsDocuments: [],
      fieldsItemsDocuments: [
        {
          key: 'stockManagementDocumentsId',
          label: 'ID Documento'
        },
        {
          key: 'createdAt',
          label: 'Data'
        },
        {
          key: 'siteName',
          label: 'Loja'
        },
        {
          key: 'sku',
          label: 'Barras'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'unity',
          label: 'Unidade'
        },
        {
          key: 'quantity',
          label: 'Quantidade'
        },
        {
          key: 'costPrice',
          label: 'Custo'
        },
        {
          key: 'salePrice',
          label: 'Venda'
        },
        {
          key: 'totalCostPrice',
          label: 'Custo Total'
        },
        {
          key: 'totalSalePrice',
          label: 'Venda Total'
        },
        {
          key: 'reason',
          label: 'Motivo'
        },
        {
          key: 'type',
          label: 'Transação'
        },
        {
          key: 'notes',
          label: 'Observação'
        },
        {
          key: 'userName',
          label: 'Usuário'
        }
      ],
      selectedOptionDate: 2,
      optionsDate: [
        {
          value: 1,
          text: 'Ontem'
        },
        {
          value: 2,
          text: 'Hoje'
        },
        {
          value: 3,
          text: 'Últimos 7 dias'
        },
        {
          value: 4,
          text: 'Últimos 15 dias'
        },
        {
          value: 5,
          text: 'Últimos 30 dias'
        },
        {
          value: 6,
          text: 'Com Intervalo de Datas'
        }
      ],
      selectedOptionCompany: null,
      optionsCompany: [],
      selectedOptionSite: null,
      optionsSite: [],
      selectedOptionReason: null,
      optionsReason: [],
      stockAdjustmentDocument: [],
      selectedOptionGroup: null,
      optionsGroup: [],
      selectedOptionAutomaticAdjustment: 0,
      optionsAutomaticAdjustment: [
        {
          value: 0,
          text: 'Exibir'
        },
        {
          value: 1,
          text: 'Não Exibir Ajustes Automáticos'
        }
      ],
      selectedOptionFilter: 1,
      optionsFilter: [
        {
          value: 1,
          text: 'Barras'
        },
        {
          value: 2,
          text: 'Descrição'
        }
      ],
      filter: '',
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD')
    }
  },

  methods: {
    redirect(ref) {
      this.$router.push(ref)
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async clearCompanyFilter() {
      this.selectedOptionCompany = null
      await this.searchDetailsItemsStockAdjustment(this.currentPage)
    },

    async clearSiteFilter() {
      this.selectedOptionSite = null
      await this.searchDetailsItemsStockAdjustment(this.currentPage)
    },

    async clearReasonFilter() {
      this.selectedOptionReason = null
      await this.searchDetailsItemsStockAdjustment(this.currentPage)
    },

    async clearGroupFilter() {
      this.selectedOptionGroup = null
      await this.searchDetailsItemsStockAdjustment(this.currentPage)
    },

    async clearFilter() {
      this.filter = ''
      await this.searchDetailsItemsStockAdjustment(this.currentPage)
    },

    navigate(page) {
      this.searchDetailsItemsStockAdjustment(page)
    },

    async exportToXLSX(page) {
      try {
        this.isLoading = true

        const url = `${config.default.urlBase}/stock-adjustment/details-items/export-to-xlsx`
        const data = this.buildDataDetailsItemsStockAdjustment(
          this.selectedOptionCompany,
          this.selectedOptionSite,
          this.selectedOptionReason,
          this.selectedOptionDate,
          this.selectedOptionFilter,
          this.selectedOptionGroup,
          this.selectedOptionAutomaticAdjustment,
          page,
          this.perPage,
          true,
          'Details'
        )

        try {
          const response = await axios({
            url,
            method: 'post',
            data,
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })

          if (response.status == 200) {
            this.isLoading = false

            await functions.openFile(response.data.url)
          }
        } catch (error) {
          console.log({
            error
          })

          this.isLoading = false

          if (!error.response) {
            await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
          }

          if (error.response.status == 403) {
            await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
            this.$router.push('login')
          } else if (error.response.status == 404) {
            this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
          } else {
            await this.$alert(`Ocorreu um erro ao exportar o relatório! ${error.response.data.message}`, 'Aviso', 'warning')
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false
      }
    },

    async getSitesByCompany(companyId) {
      const url = `${config.default.urlBase}/sites/company/${companyId}`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        this.optionsSite = []
        this.selectedOptionSite = null

        if (response.status == 200) {
          this.optionsSite = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} - ${item.name}`
              }
            })
          )

          if (this.optionsSite.length == 1) {
            this.selectedOptionSite = this.optionsSite[0].value
          }

          await this.searchDetailsItemsStockAdjustment(this.currentPage)
        }
      } catch (error) {
        console.log({
          error
        })

        this.optionsSite = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        }
      }
    },

    async getReasons() {
      try {
        const url = `${config.default.urlBase}/stock-adjustment/v1`

        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsReason = await Promise.all(
            response.data.reasons.map(item => {
              return {
                value: item.id,
                text: `${item.id} - ${item.description} - [${item.type}]`
              }
            })
          )
        }

        if (this.optionsReason.length == 1) {
          this.selectedOptionReason = this.optionsReason[0].value
        }
      } catch (error) {
        console.log({
          error
        })
      }
    },

    async getCompanies() {
      const url = `${config.default.urlBase}/companies/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        this.selectedOptionCompany = null
        this.optionsCompany = []

        if (response.status == 200) {
          this.optionsCompany = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsCompany.length == 1) {
            if (!this.selectedOptionCompany) {
              this.selectedOptionCompany = this.optionsCompany[0].value
            }

            this.getSitesByCompany(this.selectedOptionCompany)
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.optionsCompany = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    buildDataDetailsItemsStockAdjustment(
      companyId,
      siteId,
      reasonId,
      selectedOptionDate,
      filterType,
      selectedOptionGroup,
      selectedOptionAutomaticAdjustment,
      page,
      pageSize,
      exportToXLSX,
      type
    ) {
      let data = new Object()

      if (companyId) {
        data.companyId = companyId
      }

      if (siteId) {
        data.siteId = siteId
      }

      if (reasonId) {
        data.reasonId = reasonId
      }

      if (selectedOptionDate == 1) {
        data.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 2) {
        data.startDate = moment().format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 3) {
        data.startDate = moment().subtract(6, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 4) {
        data.startDate = moment().subtract(14, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 5) {
        data.startDate = moment().subtract(29, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 6) {
        if (this.startDate != null && this.endDate != null) {
          data.startDate = moment(this.startDate).format('YYYY-MM-DD 00:00:00')
          data.endDate = moment(this.endDate).format('YYYY-MM-DD 23:59:59')
        }
      }

      if (filterType == 1 && this.filter != '') {
        data.sku = this.filter
      }

      if (filterType == 2 && this.filter != '') {
        data.description = this.filter
      }

      if (selectedOptionGroup) {
        data.groupId = selectedOptionGroup
      }

      if (selectedOptionAutomaticAdjustment == 0) {
        data.isAutomaticAdjustment = true
      }
      if (selectedOptionAutomaticAdjustment == 1) {
        data.isAutomaticAdjustment = false
      }

      if (exportToXLSX) {
        data.exportToXLSX = exportToXLSX
      } else {
        data.page = page
        data.pageSize = pageSize
      }

      data.type = type

      return data
    },

    async findGroupsByCompany(companyId) {
      try {
        const url = `${config.default.urlBase}/companies/company/${companyId}/groups`

        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsGroup = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} - ${item.description}`
              }
            })
          )
        }
      } catch (error) {
        console.log({
          error
        })
      }
    },

    async searchDetailsItemsStockAdjustment(page) {
      try {
        this.isBusy = true

        const url = `${config.default.urlBase}/stock-adjustment/details-items`

        const data = this.buildDataDetailsItemsStockAdjustment(
          this.selectedOptionCompany,
          this.selectedOptionSite,
          this.selectedOptionReason,
          this.selectedOptionDate,
          this.selectedOptionFilter,
          this.selectedOptionGroup,
          this.selectedOptionAutomaticAdjustment,
          page,
          this.perPage,
          false,
          ''
        )

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.itemsDocuments = response.data.items

          this.itemsTotals = response.data.totals

          this.pagination = response.data
          this.pagination.rowsPerPage = this.perPage
          this.pagination.paginationRange = this.paginationRange

          this.paginationPageMobile = response.data
          this.paginationPageMobile.rowsPerPage = this.perPage
          this.paginationPageMobile.paginationRange = this.paginationRangeMobile

          this.totalRecords = response.data.records

          this.isBusy = false
        }
      } catch (error) {
        console.log({
          error
        })

        this.isBusy = false

        this.itemsDocuments = []
        this.itemsTotals = []
        this.totalRecords = 0
        this.pagination = {}
        this.paginationPageMobile = {}
        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
      }
    },

    focus(id) {
      document.getElementById(id).focus()
    }
  },

  computed: {
    rows() {
      return this.totalRecordsItemsDocuments
    },

    showDetailsItemsEmptyMessage() {
      return !this.isBusy && this.selectedOptionCompany && this.itemsDocuments.length === 0
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    await this.getCompanies()
    await this.getReasons()

    this.isLoading = false
  }
}
